import { render, staticRenderFns } from "./facilitysettings.vue?vue&type=template&id=4c98657c"
import script from "./facilitysettings.vue?vue&type=script&lang=js"
export * from "./facilitysettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports